import React, { useState } from "react";
import { Button, Modal, Spin, Table, Tag } from "antd";
import moment from "moment";
import { getOrderReducer } from "../redux/Reducer/orderReducer";
import { useDispatch, useSelector } from "react-redux";
import { getAdminOrderById } from "../redux/Actions";
import MyPendingOrders from "./MyPendingOrders";
import { FormatNumber } from "../Utils/cartmgt";

const onChange = (pagination, filters, sorter, extra) => {
  // console.log("params", pagination, filters, sorter, extra);
};

const OrderHistoryTable = ({ allUserOrders, isloadingAllUserOrders }) => {
  const [open, setOpen] = useState(false);
  const { adminOrderById, isloadingAdminOrderById } =
    useSelector(getOrderReducer);
  const dispatch = useDispatch();

  const handleShowUserOrderDetails = (orderid) => {
    dispatch(getAdminOrderById(orderid));
    setOpen(true);
  };

  // 👉 NEW: Helper function to calculate exact order total applying Promo logic
  const calculateCorrectOrderTotal = (record) => {
    if (!record.items || record.items.length === 0) {
      return Number(record.amount) || 0;
    }

    let calculatedTotal = 0;

    record.items.forEach((item) => {
      const product = item.product;
      const qty = Number(item.qty) || 0;

      if (
        product &&
        (product.is_promo_product === true || product.is_promo_product === 1)
      ) {
        const promoAmount = Number(product.promo_amount) || 0;
        // 👉 FIX: Multiply bundle count directly by promo amount
        calculatedTotal += qty * promoAmount;
      } else {
        calculatedTotal += (Number(product?.amount) || 0) * qty;
      }
    });

    return calculatedTotal;
  };

  // Helper to check if order has any promo items (for UI styling)
  const hasPromoInOrder = (record) => {
    return record.items?.some(
      (item) =>
        item.product?.is_promo_product === true ||
        item.product?.is_promo_product === 1,
    );
  };

  const columns = [
    {
      title: "ORDER ID",
      dataIndex: "id",
      render: (text) => <span className="orderHistory-text">{text}</span>,
    },
    {
      title: "Date",
      dataIndex: "start_date",
      render: (text, record) => (
        <span className="orderHistory-text">
          {moment(text).format("MMM Do YYYY")} <br />{" "}
          <span className="orderHistory-time">
            At {moment(text).format("h:mm A")}
          </span>
          {/* Add small Promo Tag below date if applicable */}
          {hasPromoInOrder(record) && (
            <Tag
              color="gold"
              style={{
                display: "block",
                width: "fit-content",
                marginTop: "4px",
                fontSize: "10px",
                lineHeight: "14px",
              }}
            >
              Promo
            </Tag>
          )}
        </span>
      ),
      sorter: {
        compare: (a, b) => a.start_date?.localeCompare(b?.start_date),
        multiple: 3,
      },
    },
    {
      title: "Total No Of Items",
      dataIndex: "items",
      render: (text, record) => (
        <span className="orderHistory-text">
          {text[0]?.product?.is_promo_product
            ? text[0]?.product?.unit * record.qty
            : record.qty}
        </span>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (text, record) => {
        const finalAmount = calculateCorrectOrderTotal(record);
        return (
          <span
            className="orderHistory-text"
            style={{
              fontWeight: hasPromoInOrder(record) ? "bold" : "normal",
              color: hasPromoInOrder(record) ? "#D4AF37" : "inherit",
            }}
          >
            {finalAmount === undefined || finalAmount === null
              ? "N/A"
              : FormatNumber(finalAmount)}
          </span>
        );
      },
      sorter: (a, b) =>
        calculateCorrectOrderTotal(a) - calculateCorrectOrderTotal(b),
    },
    {
      title: "Status",
      dataIndex: "order_status",
      render: (text, record) => {
        let progressClass = "";
        switch (text.id) {
          case 1:
            progressClass = "orderHistory in-progress";
            break;
          case 2:
            progressClass = "orderHistory completed";
            break;
          case 0:
            progressClass = "orderHistory rejected";
            break;
          case 6:
            progressClass = "orderHistory rejected";
            break;
          default:
            progressClass = "orderHistory completed";
        }
        return (
          <span key={text.id} className={progressClass}>
            {text.name === "Initial" ? "Incoming" : text.name}
          </span>
        );
      },
      sorter: {
        compare: (a, b) => a.order_status.id - b.order_status.id,
        multiple: 1,
      },
    },
    {
      title: "Actions",
      dataIndex: "id",
      render: (text, record) => (
        <>
          <Button
            type="text"
            onClick={() => handleShowUserOrderDetails(text)}
            className="orderHistory-view-details"
          >
            View Details
          </Button>
          <Modal
            title="Order Details"
            style={{
              top: 20,
            }}
            open={open}
            onOk={() => setOpen(false)}
            onCancel={() => setOpen(false)}
            width={1000}
            footer={null}
          >
            <Spin spinning={isloadingAdminOrderById} tip="Loading...">
              <MyPendingOrders orderDetailsData={adminOrderById} />
            </Spin>
          </Modal>
        </>
      ),
    },
  ];

  return (
    <>
      <div className="row">
        <div className="col"></div>
        <div className="col"></div>
      </div>
      <div className="row mt-5 mb-4">
        <Spin spinning={isloadingAllUserOrders} tip="Loading...">
          <Table
            columns={columns}
            dataSource={allUserOrders?.data}
            onChange={onChange}
            rowKey="id"
            scroll={{ x: 1000 }}
            pagination={{
              pageSize: 10,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "30", "40"],
              showQuickJumper: true,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
              style: {
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
              },
            }}
          />
        </Spin>
      </div>
    </>
  );
};

export default OrderHistoryTable;
